import React from 'react';
import { Link } from 'react-router-dom';
import { FaDiscord, FaTwitter } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container-custom">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="heading-5 mb-4">Fight for Erebus</h3>
            <p className="body-small text-text-secondary">
              Master the elements. Conquer the arena.
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-4 mt-4">
              <a 
                href="https://discord.gg/NRqFJAx8" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-text-secondary hover:text-[#5865F2] transition-colors"
                title="Discord"
              >
                <FaDiscord size={24} />
              </a>
              <a 
                href="https://x.com/FightForErebus" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-text-secondary hover:text-white transition-colors"
                title="Twitter/X"
              >
                <FaTwitter size={22} />
              </a>
            </div>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4 className="caption mb-4">Game</h4>
              <button onClick={() => document.getElementById('features').scrollIntoView({ behavior: 'smooth' })} className="footer-link">
                Features
              </button>
              <button onClick={() => document.getElementById('elements').scrollIntoView({ behavior: 'smooth' })} className="footer-link">
                Elements
              </button>
              <button onClick={() => document.getElementById('beta').scrollIntoView({ behavior: 'smooth' })} className="footer-link">
                Beta Access
              </button>
            </div>

            <div className="footer-column">
              <h4 className="caption mb-4">Community</h4>
              <Link to="/gallery" className="footer-link">Gallery</Link>
              <a href="https://discord.gg/NRqFJAx8" target="_blank" rel="noopener noreferrer" className="footer-link">Discord</a>
              <a href="https://x.com/FightForErebus" target="_blank" rel="noopener noreferrer" className="footer-link">Twitter</a>
            </div>

            <div className="footer-column">
              <h4 className="caption mb-4">Support</h4>
              <a href="#" className="footer-link">FAQ</a>
              <a href="#" className="footer-link">Contact</a>
              <a href="#" className="footer-link">Privacy</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="body-small text-text-secondary">
            © {currentYear} Fight for Erebus. Built with Unreal Engine.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
